<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="alert-action"
    :class="
      cn(
        'col-start-[-2] row-start-1 flex h-0 items-center gap-2 self-center group-has-data-[slot=alert-description]/alert:row-end-3',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
